module.exports = __webpack_public_path__ + "static/img/coupon-selected.b87d9c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/coupon/coupon-selected.png
// module id = XtIy
// module chunks = 4